/**
 * RateHawk hotel amenities come as raw keys ("has_internet", "has_kids",
 * "non-smoking", ...). Map them to localized human-readable labels and never
 * leak raw keys (or the "has_" prefix) to the UI.
 */

const AMENITY_LABELS = {
  has_internet: { lv: "Internets", en: "Internet", ru: "Интернет", lt: "Internetas" },
  has_wifi: { lv: "Wi-Fi", en: "Wi-Fi", ru: "Wi-Fi", lt: "Wi-Fi" },
  has_tv: { lv: "TV", en: "TV", ru: "Телевизор", lt: "TV" },
  has_fridge: { lv: "Ledusskapis", en: "Fridge", ru: "Холодильник", lt: "Šaldytuvas" },
  has_air_conditioning: {
    lv: "Gaisa kondicionētājs",
    en: "Air conditioning",
    ru: "Кондиционер",
    lt: "Oro kondicionierius",
  },
  has_kitchen: { lv: "Virtuve", en: "Kitchen", ru: "Кухня", lt: "Virtuvė" },
  has_kitchenette: {
    lv: "Neliela virtuve",
    en: "Kitchenette",
    ru: "Мини-кухня",
    lt: "Mini virtuvėlė",
  },
  has_room_service: {
    lv: "Apkalpošana numurā",
    en: "Room service",
    ru: "Обслуживание в номере",
    lt: "Aptarnavimas kambaryje",
  },
  has_phone: { lv: "Tālrunis", en: "Phone", ru: "Телефон", lt: "Telefonas" },
  has_safe: { lv: "Seifs", en: "Safe", ru: "Сейф", lt: "Seifas" },
  has_bathtub: { lv: "Vanna", en: "Bathtub", ru: "Ванна", lt: "Vonia" },
  has_shower: { lv: "Duša", en: "Shower", ru: "Душ", lt: "Dušas" },
  has_balcony: { lv: "Balkons", en: "Balcony", ru: "Балкон", lt: "Balkonas" },
  has_terrace: { lv: "Terase", en: "Terrace", ru: "Терраса", lt: "Terasa" },
  has_balcony_terrace: {
    lv: "Balkons/terase",
    en: "Balcony/terrace",
    ru: "Балкон/терраса",
    lt: "Balkonas/terasa",
  },
  has_view: { lv: "Skats", en: "View", ru: "Вид", lt: "Vaizdas" },
  has_heating: { lv: "Apkure", en: "Heating", ru: "Отопление", lt: "Šildymas" },
  has_kids: { lv: "Piemērots bērniem", en: "Kids friendly", ru: "Подходит для детей", lt: "Tinka vaikams" },
  has_meal: { lv: "Ēdināšana", en: "Meal service", ru: "Питание", lt: "Maitinimas" },
  has_disabled_support: {
    lv: "Pielāgots cilvēkiem ar īpašām vajadzībām",
    en: "Disabled support",
    ru: "Поддержка для людей с ограниченными возможностями",
    lt: "Pritaikyta neįgaliesiems",
  },
  has_parking: { lv: "Autostāvvieta", en: "Parking", ru: "Парковка", lt: "Parkavimas" },
  has_pool: { lv: "Baseins", en: "Pool", ru: "Бассейн", lt: "Baseinas" },
  has_gym: { lv: "Trenažieru zāle", en: "Gym", ru: "Тренажёрный зал", lt: "Sporto salė" },
  has_spa: { lv: "SPA", en: "SPA", ru: "СПА", lt: "SPA" },
  has_breakfast: { lv: "Brokastis", en: "Breakfast", ru: "Завтрак", lt: "Pusryčiai" },
  non_smoking: { lv: "Nesmēķētāju", en: "Non-smoking", ru: "Для некурящих", lt: "Nerūkantiems" },
  "non-smoking": { lv: "Nesmēķētāju", en: "Non-smoking", ru: "Для некурящих", lt: "Nerūkantiems" },
  smoking: { lv: "Smēķētāju", en: "Smoking", ru: "Для курящих", lt: "Rūkantiems" },
  extra_bed: { lv: "Papildu gulta", en: "Extra bed", ru: "Дополнительная кровать", lt: "Papildoma lova" },
  has_sea_view: { lv: "Skats uz jūru", en: "Sea view", ru: "Вид на море", lt: "Vaizdas į jūrą" },
  has_lake_view: { lv: "Skats uz ezeru", en: "Lake view", ru: "Вид на озеро", lt: "Vaizdas į ežerą" },
  has_city_view: { lv: "Skats uz pilsētu", en: "City view", ru: "Вид на город", lt: "Vaizdas į miestą" },
  has_garden_view: { lv: "Skats uz dārzu", en: "Garden view", ru: "Вид на сад", lt: "Vaizdas į sodą" },
  has_coffee_maker: {
    lv: "Kafijas aparāts",
    en: "Coffee maker",
    ru: "Кофеварка",
    lt: "Kavos aparatas",
  },
  has_hairdryer: { lv: "Fēns", en: "Hairdryer", ru: "Фен", lt: "Plaukų džiovintuvas" },
  has_toiletries: {
    lv: "Piederumi vannas istabai",
    en: "Toiletries",
    ru: "Туалетные принадлежности",
    lt: "Higienos priemonės",
  },
  has_slippers: { lv: "Čības", en: "Slippers", ru: "Тапочки", lt: "Šlepetės" },
  has_robe: { lv: "Halāts", en: "Bathrobe", ru: "Халат", lt: "Chalatas" },
  has_minibar: { lv: "Mini bārs", en: "Minibar", ru: "Мини-бар", lt: "Mini baras" },
  has_microwave: { lv: "Mikroviļņu krāsns", en: "Microwave", ru: "Микроволновка", lt: "Mikrobangų krosnelė" },
  has_dishwasher: { lv: "Trauku mazgājamā mašīna", en: "Dishwasher", ru: "Посудомоечная машина", lt: "Indaplovė" },
  has_washing_machine: {
    lv: "Veļas mazgājamā mašīna",
    en: "Washing machine",
    ru: "Стиральная машина",
    lt: "Skalbyklė",
  },
  // RateHawk also returns plain (non-has_) keys and pre-humanized English
  // display names; normalize both before lookup.
  air_conditioning: {
    lv: "Gaisa kondicionētājs",
    en: "Air conditioning",
    ru: "Кондиционер",
    lt: "Oro kondicionierius",
  },
  hairdryer: { lv: "Fēns", en: "Hairdryer", ru: "Фен", lt: "Plaukų džiovintuvas" },
  private_bathroom: {
    lv: "Privāta vannas istaba",
    en: "Private bathroom",
    ru: "Собственная ванная комната",
    lt: "Privatus vonios kambarys",
  },
  wi_fi: { lv: "Wi-Fi", en: "Wi-Fi", ru: "Wi-Fi", lt: "Wi-Fi" },
  fridge: { lv: "Ledusskapis", en: "Fridge", ru: "Холодильник", lt: "Šaldytuvas" },
  heating: { lv: "Apkure", en: "Heating", ru: "Отопление", lt: "Šildymas" },
  iron: { lv: "Gludeklis", en: "Iron", ru: "Утюг", lt: "Lygintuvas" },
  kitchen: { lv: "Virtuve", en: "Kitchen", ru: "Кухня", lt: "Virtuvė" },
  microwave: { lv: "Mikroviļņu krāsns", en: "Microwave", ru: "Микроволновка", lt: "Mikrobangų krosnelė" },
  shower: { lv: "Duša", en: "Shower", ru: "Душ", lt: "Dušas" },
  tea: { lv: "Tējkanna", en: "Tea kettle", ru: "Чайник", lt: "Arbatinukas" },
  toiletries: {
    lv: "Piederumi vannas istabai",
    en: "Toiletries",
    ru: "Туалетные принадлежности",
    lt: "Higienos priemonės",
  },
  towels: { lv: "Dvieļi", en: "Towels", ru: "Полотенца", lt: "Rankšluosčiai" },
  tv: { lv: "TV", en: "TV", ru: "Телевизор", lt: "TV" },
  washing_machine: {
    lv: "Veļas mazgājamā mašīna",
    en: "Washing machine",
    ru: "Стиральная машина",
    lt: "Skalbyklė",
  },
  microwave_oven: {
    lv: "Mikroviļņu krāsns",
    en: "Microwave oven",
    ru: "Микроволновка",
    lt: "Mikrobangų krosnelė",
  },
  smoke_free_property: {
    lv: "Nesmēķētāju telpas",
    en: "Smoke-free property",
    ru: "Номер для некурящих",
    lt: "Nerūkantiems skirtos patalpos",
  },
  no_elevators: {
    lv: "Be lifta",
    en: "No elevators",
    ru: "Без лифта",
    lt: "Be lifto",
  },
  pets_not_allowed: {
    lv: "Mājdzīvnieki nav atļauti",
    en: "Pets not allowed",
    ru: "Животные не допускаются",
    lt: "Augintiniai neleidžiami",
  },
};

const FALLBACK_LANGS = ["lv", "en", "ru", "lt"];

/**
 * @param {string} key Raw amenity key from the provider ("has_internet").
 * @param {string} currentLanguage Current UI language code.
 * @returns {string} Localized label; never the raw key.
 */
export function getAmenityLabel(key, currentLanguage) {
  if (!key) return "";
  const normalized = String(key)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/-+/g, "_");
  const known = AMENITY_LABELS[normalized];
  if (known) {
    return known[currentLanguage] || known.en;
  }
  // Unknown keys: strip the "has_" prefix, turn underscores into spaces,
  // capitalize the first letter, and use the English fallback wording.
  const stripped = normalized.replace(/^has_/i, "").replace(/^has-?/i, "").replace(/[_-]+/g, " ");
  const humanized = stripped
    .split(" ")
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : w))
    .join(" ");
  return humanized || normalized;
}

export const AMENITY_LANG_CODES = FALLBACK_LANGS;
